import { render, staticRenderFns } from "./activity-view.vue?vue&type=template&id=3efd655c"
import script from "./activity-view.vue?vue&type=script&lang=ts"
export * from "./activity-view.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports